ui.listado = function(){
	/**
	 * Obtiene la lista de items actualmente seleccionados en el listado
	 * @param jQuery jqListado Listado en el que buscar
	 * @return array Lista de ids
	 */
	function obtenerItemsSeleccionados(jqListado){
		var ids = [];
		jqListado.find(".listadoInner .itemSel").each(
			function(){
				ids.push(nbf.extraerDatos($(this)));
			}
		);
		return ids;
	}
	
	/**
	 * Marca el/los items pasados como seleccionados
	 * @param jQuery jqItem Item/s a seleccionar
	 * @param bool marcar A true/false si queremos forzar, no pasar para que haga toggle
	 */
	function seleccionarItem(jqItem,marcar){
		var clase = "itemSel";
		jqItem = jqItem.filter(".item");
		if(jqItem.size()>0){
			jqItem.each(
				function(){
					var item = $(this);
					var input = item.find(".checkSel input");
					if(marcar===undefined)
						item.toggleClass(clase);
					else if(marcar)
						item.addClass(clase);
					else
						item.removeClass(clase);
					if(input.size()>0)
						input.get(0).checked = item.hasClass(clase);
				}
			);
			var jqListado = jqItem.eq(0).closest(".listado");
			var jqItems = jqListado.find(".item");
			var jqItemsSel = jqItems.filter(".itemSel");
			var clsA = "listadoSeleccionActiva";
			var clsAAll = "listadoSeleccionActivaAll";
			if(jqItemsSel.size()>0){
				jqListado.addClass(clsA);
				if(jqItems.size()==jqItemsSel.size())
					jqListado.addClass(clsAAll);
				else
					jqListado.removeClass(clsAAll);
			}else
				jqListado.removeClass(clsA+" "+clsAAll);
		}
	}
	

	
	/**
	 * Marca todos los items pasados como seleccionados/no seleccionados
	 * @param jQuery jqListado Listado a seleccionar
	 * @param bool marcar A true/false si queremos marcar o desmarcar, no pasar para que haga toggle
	 */
	function seleccionarItemsTodos(jqListado,marcar){
		jqListado.find(".listadoInner").find(".item").seleccionarItem(marcar);
	}
	
	//extendemos funcionalidad jquery para listados
	jQuery.fn.extend(
		{
			"obtenerItemsSeleccionados":function(){
				 return obtenerItemsSeleccionados(this);
			},
			"seleccionarItem":function(marcar){
				 return seleccionarItem(this,marcar);
			},
			"seleccionarItemsTodos":function(marcar){
				 return seleccionarItemsTodos(this,marcar);
			}
		}
	);
	
	ui.ready(
		".listadoSeleccionable",
		function(jq){
			jq.find(".checkSel input").click(
				function(){
					$(this).closest(".item").seleccionarItem(this.checked);
				}
			);
			
			jq.find(".selTodo").click(
				function(ev){
					ev.preventDefault();
					jq.seleccionarItemsTodos();
				}
			);
		}
	);
	
	return {
		"obtenerItemsSeleccionados":obtenerItemsSeleccionados,
		"seleccionarItem":seleccionarItem,
		"seleccionarItemsTodos":seleccionarItemsTodos
	};
}();